import { jsPDF } from "jspdf";

const clean = (t) => String(t).replace(/[‘’]/g, "'").replace(/[“”]/g, '"').replace(/[–—]/g, "-").replace(/·/g, "-");

export function downloadPlan(plan, { concerns = [] } = {}) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const M = 50;
  const W = doc.internal.pageSize.getWidth() - M * 2;
  const H = doc.internal.pageSize.getHeight();
  let y = M;
  const write = (t, { size = 11, bold = false, color = [36, 40, 43], gap = 6, indent = 0 } = {}) => {
    doc.setFont("helvetica", bold ? "bold" : "normal");
    doc.setFontSize(size);
    doc.setTextColor(...color);
    const lh = size * 1.4;
    doc.splitTextToSize(clean(t), W - indent).forEach((line) => {
      if (y + lh > H - M) { doc.addPage(); y = M; }
      doc.text(line, M + indent, y);
      y += lh;
    });
    y += gap;
  };
  const heading = (t) => { y += 10; write(t, { size: 14, bold: true, color: [47, 107, 106] }); };
  const list = (items) => items.forEach((i) => write(`-  ${i}`, { gap: 3, indent: 6 }));
  const origin = window.location.origin;

  write("Addiction & Us", { size: 10, color: [95, 104, 111] });
  write("My next steps", { size: 24, bold: true, gap: 4 });
  write(`Created ${new Date().toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}. General information only, not professional advice.`, { size: 9, color: [95, 104, 111] });
  write("If anyone is in immediate danger, call 999. Urgent medical advice: NHS 111. Samaritans: 116 123 (free, 24 hours).", { size: 10, bold: true, color: [158, 79, 55] });
  if (concerns.length) { heading("What I chose"); list(concerns); }
  heading(`One thing I can do today: ${plan.today.title}`);
  write(plan.today.text);
  heading("What matters right now"); list(plan.matters);
  heading("More things I could try"); list(plan.actions);
  heading("What can wait"); list(plan.wait);
  if (plan.youMatter) { heading("I matter too"); write(plan.youMatter); }
  if (plan.notes.length) { heading("Also worth knowing"); list(plan.notes); }
  heading("Useful reading");
  list(plan.articles.map((a) => `${a.title}: ${origin}/${a.hub}/${a.slug}`));
  heading("Support I can contact");
  plan.services.forEach((s) => {
    write(s.name, { bold: true, gap: 1 });
    const contacts = s.contacts.map((c) => `${c.label}: ${c.value}`).join("   ");
    if (contacts) write(contacts, { gap: 1 });
    if (s.availability) write(s.availability, { size: 9, color: [95, 104, 111], gap: 1 });
    write(s.website, { size: 9, color: [47, 107, 106] });
  });
  y += 10;
  write("These organisations are independent of Addiction & Us. Please check their websites for the latest opening hours.", { size: 9, color: [95, 104, 111] });
  doc.save("my-next-steps-addiction-and-us.pdf");
}
